import type { FC } from 'react';
import { useEffect } from 'react';

import { useYM } from 'YM/Context';
import { GoalType } from 'YM/declare';

import PreparationContextProvider from './Context';
import ControlPanel from './ControlPanel';
import styles from './styles.module.scss';

const Preparation: FC = () => {
    const { triggerYM } = useYM();

    useEffect(() => {
        triggerYM({ goal: GoalType.PREPARATION_PAGE_VIEW });
    }, []);

    return (
        <PreparationContextProvider>
            <div className={styles.wrapper}>
                <ControlPanel />
            </div>
        </PreparationContextProvider>
    );
};

export default Preparation;
